/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Meta_Pagetitle1Inputs */

const ja_company_meta_pagetitle1 = /** @type {(inputs: Company_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const en_company_meta_pagetitle1 = /** @type {(inputs: Company_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Company_Meta_Pagetitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_meta_pagetitle1 = /** @type {((inputs?: Company_Meta_Pagetitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Meta_Pagetitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_meta_pagetitle1(inputs)
	return en_company_meta_pagetitle1(inputs)
});
export { company_meta_pagetitle1 as "company_meta_pageTitle" }